import React from 'react';

import EventList from '../../../react4xp/components/EventList'
import Section from '../../../react4xp/components/Section'

import dayjs from 'dayjs';
import 'dayjs/locale/nb'

function EventListPart(props) {
	const eventCards = props.events
		.map(event => ({
			startDate: event.startDate && {
				day: dayjs(event.startDate).format('DD'),
				month: dayjs(event.startDate).format('MMMM'),
				year: dayjs(event.startDate).format('YYYY')
			},
			endDate: event.endDate && {
				day: dayjs(event.endDate).format('DD'),
				month: dayjs(event.endDate).format('MMMM'),
				year: dayjs(event.endDate).format('YYYY')
			},
			title: event.title,
			address: event.location,
			stand: event.stand
		}))

	return (
		<Section>
			<EventList
				tag={props.tag}
				title={props.title}
				img={{
					src: props.image?.link,
					srcMobile: props.imageMobile?.link,
					alt: props.image.alt
				}}
				cards={eventCards}
				cta={props.cta || undefined}
				color={props.color}
			/>
		</Section>
	)
}

export default (props) => <EventListPart {...props} />
